import { Box, Typography } from "@mui/material";
import React from "react";
import notSecretaries from "../../../../assets/image/notSecretaries.png";
import ICON from "../../../../icon/config.json";

export default function Secretaries() {
  console.log(ICON,"mmd");
  return (
    <>
    <Typography
    mt="40px"
      //   onClick={() => setSelected(0)}
      className={"styleSelectedTab"}
    >
      {"منشی بخش"}
    </Typography>
    <Box height="70vh" display="flex" alignItems="center" justifyContent="center">
    <img src={notSecretaries} style={{ marginTop: "50px" }} />
  </Box>
  {/* <Box className={`doctor`}  width="100px" height="100px" /> */}
  
    </>
  );
}
